import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { LoginButton } from "../buttons/login-button";
import { LogoutButton } from "../buttons/logout-button";
import BibleVerse from "../start/BibleVerse";
import "./Header.css";

const Header = () => {
  const { isAuthenticated } = useAuth0();
  const [isMobile] = useState(window.innerWidth < 800);

  return (
    <div className="header">
      <div className="title">
        <h1>Hoppets Folk</h1>
        {!isMobile && <BibleVerse />}
      </div>
      <div className="menuBar">
        {isAuthenticated ? (
          <nav className="menuItems">
            <NavLink to="../">Start</NavLink>
            {isMobile ? <NavLink to="../calendar">Kalender</NavLink> : <></>}
            <NavLink to="../profile">Profil</NavLink>
            <NavLink to="../network">Nätverk</NavLink>
            <LogoutButton />
          </nav>
        ) : (
          <nav className="menuItems">
            <NavLink to="../">Start</NavLink>
            {isMobile ? <NavLink to="../calendar">Kalender</NavLink> : <></>}
            <LoginButton />
          </nav>
        )}
      </div>
    </div>
  );
};

export default Header;

/*
import { Link } from "react-router-dom";
import { useEffect, useContext } from "react";
import { UserContext } from "./Layout";
import "./MenuBar.scss";

export default function MenuBar() {

  return (
    <div className="menuBar">
      <div className="title">
        <h1><br></br>Hoppets Folk</h1>
      </div>
        <nav>
          <div className="menuItems">
            {isLoggedIn ? (
              <>
                <Link to="/startLoggedIn">Start</Link>
                {isMobile ? <Link to="/calendar">Kalender</Link> : <></>}
                <Link to="/profile">Profil</Link>
                <Link to="/network">Nätverk</Link>
                <Link to="/logout">Logga ut</Link>
              </>
            ) : (
              <>
                <Link to="/"> Start</Link>
                {isMobile ? <Link to="/calendar">Kalender</Link> : <></>}
                <Link to="/login"> Logga in </Link>
              </>
            )}
          </div>
        </nav>
      </div>
  );
}
*/
